import { render, staticRenderFns } from "./ApproveContactDialog.vue?vue&type=template&id=e10927d8&scoped=true"
import script from "./ApproveContactDialog.vue?vue&type=script&lang=js"
export * from "./ApproveContactDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveContactDialog.vue?vue&type=style&index=0&id=e10927d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10927d8",
  null
  
)

export default component.exports